import React, { useRef, useState } from "react";
import WindowChrome from "./WindowChrome.jsx";
import { HERO_VIDEO_POSTER, HERO_VIDEO_SRC } from "./heroVideo.js";
import { useVideoEngagementTracking } from "./useVideoEngagementTracking.js";

const PlayIcon = () => (
  <span className="cursor-video-play-icon">
    <svg
      className="cursor-play-icon"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  </span>
);

const QuietVideoPlayer = ({
  src = HERO_VIDEO_SRC,
  poster = HERO_VIDEO_POSTER,
  chromeTitle = "FractoLabs Demo",
  playLabel = "Play demo video",
}) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasError, setHasError] = useState(false);

  useVideoEngagementTracking(videoRef, { enabled: isPlaying && !hasError });

  const handlePlay = async () => {
    setIsPlaying(true);
    try {
      await videoRef.current?.play();
    } catch (err) {
      console.warn("[QuietVideoPlayer] playback failed", err);
      setHasError(true);
    }
  };

  const handleVideoError = () => {
    setHasError(true);
  };

  return (
    <div className="cursor-video-wrap" data-testid="quiet-video">
      <div className="cursor-video-window">
        <WindowChrome title={chromeTitle} />
        <div className="cursor-video-body">
          {!hasError && (
            <video
              ref={videoRef}
              src={src}
              poster={poster}
              controls={isPlaying}
              playsInline
              preload="metadata"
              onError={handleVideoError}
              data-testid="quiet-video-player"
              className={isPlaying ? "" : "hidden"}
            />
          )}
          {!isPlaying && !hasError && (
            <>
              <img
                src={poster}
                alt=""
                className="cursor-video-thumbnail"
                loading="eager"
              />
              <button
                type="button"
                className="cursor-video-play"
                onClick={handlePlay}
                aria-label={playLabel}
                data-testid="quiet-video-play"
              >
                <PlayIcon />
              </button>
            </>
          )}
        </div>
      </div>
      {hasError && (
        <p className="text-center text-sm text-[#9CA3AF] mt-3" data-testid="quiet-video-unavailable">
          Video unavailable
        </p>
      )}
    </div>
  );
};

export default QuietVideoPlayer;
